import { MenuModel, CreateForm } from '@/models/Menu'

const actions = {
  async SEARCH({ commit }, { id, keyword, pageSize, pageNo }) {
    const searchResult = await MenuModel.search({
      id,
      keyword,
      pageSize,
      pageNo,
    })
    commit('SET_SEARCH_RESULT', searchResult)
    return
  },
  async SEARCH_FOR_ADVERTISER({ commit }, advertiserId) {
    const searchResult = await MenuModel.searchForAdvertiser(advertiserId)
    commit('SET_SEARCH_RESULT', searchResult)
    return
  },
  async SEARCH_FOR_SIMULATION_PLAN({ commit }, advertiserId, agencyMargin) {
    const searchResult = await MenuModel.searchForSimulationPlan(
      advertiserId,
      agencyMargin,
    )
    commit('SET_SEARCH_RESULT', searchResult)
    return
  },
  async SEARCH_ADVERTISER({ commit }, keyword) {
    const ret = await CreateForm.searchAdvertiser({
      keyword,
      minPermissionLevel: 'admin',
    })
    commit('SET_ADVERTISER_LIST', ret.items)
  },
  async SEARCH_INSERTION_ORDER({ commit }, { keyword, id }) {
    const ret = await CreateForm.searchInsertionOrder({ keyword, id })
    commit('SET_INSERTION_ORDER_LIST', ret.items)
  },
}

export default actions
